/*
 * This file is part of the https://gitlab-intern.easd-support.de/easd/p26s26_energie_watchdog project.
 *
 * (c) 2026 EA Systems Dresden GmbH
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

/* Import configuration */
import { WATER_LOSS_OVERVIEW_CONFIGS } from '@/config/kpi/overviewAnomalyConfig';

/* Import components */
import AnomalyMetricsOverview from '@/components/tabs/overview/metrics/AnomalyMetricsOverview';

function WaterLossOverviewTab() {
    return (
        <AnomalyMetricsOverview
            anomalyConfigs={WATER_LOSS_OVERVIEW_CONFIGS}
            description="Overview of all available water-loss metrics."
            heading="Water loss"
            idPrefix="water-loss"
        />
    );
}

export default WaterLossOverviewTab;
